import { Hub } from '@aws-amplify/core';
import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

/** Shown at /auth/callback while Amplify finishes the managed-login code exchange. */
const AuthCallback = () => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(
    () =>
      Hub.listen('auth', ({ payload }) => {
        if (payload.event === 'signInWithRedirect_failure')
          setErrorMessage('Sign-in did not complete. Please try again.');
      }),
    [],
  );

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      {errorMessage ? (
        <Typography color='error'>{errorMessage}</Typography>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default AuthCallback;
